import React from 'react';
import { View, Text } from 'react-native';

export const NotFound = () => {
  return (
    <View>
      <Text>404 Not Found</Text>
    </View>
  );
};
